<template>
  <a-config-provider :locale="locale" :getPopupContainer="getPopupContainer">
    <div id="app">
      <Basic class="sub-frame"/>
    </div>
  </a-config-provider>
</template>

<script>
import Basic from './views/Basic.vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'

import { message, notification, Modal, Drawer } from 'ant-design-vue'

// 防止子应用样式污染
message.config({
  getContainer: () => {
    const containers = document.getElementsByClassName('sub-frame')
    return containers[containers.length - 1]
  },
})
notification.config({
  getContainer: () => {
    const containers = document.getElementsByClassName('sub-frame')
    return containers[containers.length - 1]
  },
})
Modal.props.getContainer.default = () => {
  const containers = document.getElementsByClassName('sub-frame')
  return containers[containers.length - 1]
}
Drawer.props.getContainer.default = false

export default {
  components: { Basic },
  data() {
    return {
      locale: zhCN,
    }
  },
  methods: {
    getPopupContainer(el, dialogContext) {
      if (dialogContext) {
        return dialogContext.getDialogWrap()
      } else {
        const containers = document.getElementsByClassName('sub-frame')
        return containers[containers.length - 1]
      }
    },
  },
  destroyed() {
    message.destroy()
  }
}
</script>

<style lang="less">
#app {
  // height: 100vh;
  overflow-y: auto;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
ul li::before {
  content: "";
}
</style>
